module.exports = __webpack_public_path__ + "8cdc8fcd4cae04472a0d44466902efa1.mp4";